/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type UserSettingsFetchQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserSettingsFetchQuery = {
	__typename?: "Query";
	userSettings: {
		__typename?: "UserSettingsResponse";
		tradingDisabled: boolean;
		pepCheck: boolean;
		advanceTradingTerms: boolean;
		visionBonus?: boolean | null;
		visionBonusUserJourney: string;
	};
};

export const UserSettingsFetchDocument = gql`
	query userSettingsFetch {
		userSettings {
			tradingDisabled
			pepCheck
			advanceTradingTerms
			visionBonus
			visionBonusUserJourney
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class UserSettingsFetchGQLService extends Apollo.Query<UserSettingsFetchQuery, UserSettingsFetchQueryVariables> {
	document = UserSettingsFetchDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
